(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyora-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-vrcart-change]');
    if (!(button instanceof HTMLButtonElement)) return;
    const input = document.getElementById(button.getAttribute('aria-controls') || '');
    if (!(input instanceof HTMLInputElement)) return;
    const current = Number.parseInt(input.value || '0', 10);
    const change = Number.parseInt(button.dataset.vrcartChange || '0', 10);
    input.value = String(Math.max(0, current + change));
    const form = button.closest('[data-vrcart-form]');
    const update = form?.querySelector('button[name="update"]');
    if (form instanceof HTMLFormElement && update instanceof HTMLButtonElement) form.requestSubmit(update);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyora-conversion-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vc-quantity-offers').forEach((offers) => {
  const form = offers.closest('form');
  const input = form?.querySelector('.vc-quantity-input');
  const buttons = [...offers.querySelectorAll('[data-quantity]')];
  const colors = offers.querySelector('[data-bundle-colors]');
  const colorRows = [...offers.querySelectorAll('[data-bundle-color-row]')];
  const primaryVariant = form?.querySelector('select[name="id"]');
  const submitButton = form?.querySelector('[data-bundle-submit]');
  const status = offers.querySelector('[data-bundle-status]');
  if (!form || !input || buttons.length === 0) return;

  let previousQuantity = 1;
  const selectQuantity = (button) => {
    const parsedQuantity = Number.parseInt(button.dataset.quantity || '1', 10);
    const quantity = Number.isFinite(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;
    input.value = String(quantity);

    if (previousQuantity === 1 && primaryVariant instanceof HTMLSelectElement) {
      colorRows.forEach((row) => {
        const select = row.querySelector('[data-bundle-color]');
        if (select instanceof HTMLSelectElement) select.value = primaryVariant.value;
      });
    }

    buttons.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });

    if (colors instanceof HTMLElement) colors.hidden = quantity === 1;
    colorRows.forEach((row, index) => {
      if (row instanceof HTMLElement) row.hidden = quantity === 1 || index >= quantity;
    });

    if (submitButton instanceof HTMLButtonElement) {
      submitButton.textContent = quantity === 1 ? submitButton.dataset.singleLabel || '' : submitButton.dataset.bundleLabel || '';
    }
    if (status) status.textContent = '';
    previousQuantity = quantity;
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => selectQuantity(button));
  });

  primaryVariant?.addEventListener('change', () => {
    if (previousQuantity !== 1 || !(primaryVariant instanceof HTMLSelectElement)) return;
    colorRows.forEach((row) => {
      const select = row.querySelector('[data-bundle-color]');
      if (select instanceof HTMLSelectElement) select.value = primaryVariant.value;
    });
  });

  form.addEventListener('submit', async (event) => {
    const quantity = Number.parseInt(input.value || '1', 10);
    if (quantity <= 1) return;

    event.preventDefault();
    const counts = new Map();
    colorRows.slice(0, quantity).forEach((row) => {
      const select = row.querySelector('[data-bundle-color]');
      if (!(select instanceof HTMLSelectElement) || !select.value) return;
      counts.set(select.value, (counts.get(select.value) || 0) + 1);
    });
    const items = [...counts.entries()].map(([id, itemQuantity]) => ({
      id: Number.parseInt(id, 10),
      quantity: itemQuantity,
    }));
    if (items.length === 0 || !(submitButton instanceof HTMLButtonElement)) return;

    submitButton.disabled = true;
    submitButton.textContent = submitButton.dataset.addingLabel || '';
    if (status) status.textContent = '';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Cart error');
      window.location.assign(`${root}cart`);
    } catch (error) {
      if (status) status.textContent = offers.dataset.bundleError || '';
      submitButton.disabled = false;
      submitButton.textContent = submitButton.dataset.bundleLabel || '';
    }
  });
});

document.querySelectorAll('.vc-product-disclosures details').forEach((disclosure) => {
  disclosure.addEventListener('toggle', () => {
    if (!disclosure.open) return;
    disclosure.parentElement?.querySelectorAll('details[open]').forEach((item) => {
      if (item !== disclosure) item.removeAttribute('open');
    });
  });
});

document.querySelectorAll('.vc-mobile-menu').forEach((menu) => {
  const summary = menu.querySelector('summary');
  const hiddenLabel = summary?.querySelector('.vc-visually-hidden');
  const openLabel = menu.dataset.openLabel || 'Menu';
  const closeLabel = menu.dataset.closeLabel || openLabel;
  const syncMenuState = () => {
    const label = menu.open ? closeLabel : openLabel;
    summary?.setAttribute('aria-label', label);
    if (hiddenLabel) hiddenLabel.textContent = label;
    document.body.classList.toggle('vc-menu-open', menu.open);
  };
  menu.addEventListener('toggle', syncMenuState);
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) {
      menu.removeAttribute('open');
      summary?.focus();
    }
  });
  syncMenuState();
});

const vcLocalizeReviewControls = () => {
  document.querySelectorAll('.vc-review-widget').forEach((widget) => {
    const pageTemplate = widget.dataset.pageLabel || 'Go to page [page]';
    widget.querySelectorAll('.jm-pagination-controls__button--page').forEach((button) => {
      const page = button.textContent.trim();
      if (page) button.setAttribute('aria-label', pageTemplate.replace('[page]', page));
    });
    const navigation = [...widget.querySelectorAll('.jm-pagination-controls__button--nav')];
    navigation[0]?.setAttribute('aria-label', widget.dataset.previousLabel || 'Previous review page');
    navigation.at(-1)?.setAttribute('aria-label', widget.dataset.nextLabel || 'Next review page');
  });
};

vcLocalizeReviewControls();
document.querySelectorAll('.vc-review-widget').forEach((widget) => {
  const observer = new MutationObserver(vcLocalizeReviewControls);
  observer.observe(widget, { childList: true, subtree: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyora-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vy-ref-compare__range').forEach((range) => {
    const update = () => range.closest('.vy-ref-compare__stage').style.setProperty('--position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyora-reference-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-veyora-language]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veyora-reference-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.vrl').forEach((landing) => {
    const selectors = [...landing.querySelectorAll('[data-vrl-variant-select]')];
    const cutouts = [...landing.querySelectorAll('[data-vrl-cutout]')];

    selectors.forEach((selector) => {
      selector.addEventListener('change', () => {
        const option = selector.options[selector.selectedIndex];
        const imageUrl = option?.dataset.cutoutUrl;
        if (!imageUrl) return;

        selectors.forEach((otherSelector) => {
          if (otherSelector !== selector) otherSelector.value = selector.value;
        });
        cutouts.forEach((image) => {
          image.src = imageUrl;
          image.removeAttribute('srcset');
          image.alt = option.dataset.cutoutAlt || image.alt;
        });
      });
    });

    const bundleForms = [...landing.querySelectorAll('.vrl-hero__form, .vrl-product__form')];

    bundleForms.forEach((form) => {
      const choices = [...form.querySelectorAll('[data-vrl-bundle-choice]')];
      const colourRows = [...form.querySelectorAll('[data-vrl-bundle-colour-row]')];
      const submitButton = form.querySelector('[data-vrl-bundle-submit]');
      const status = form.querySelector('[data-vrl-bundle-status]');

      if (!(form instanceof HTMLFormElement) || !(submitButton instanceof HTMLButtonElement) || !(status instanceof HTMLElement)) return;

      const updateBundle = () => {
        const choice = choices.find((item) => item.checked);
        if (!(choice instanceof HTMLInputElement)) return;
        const quantity = Number.parseInt(choice.value, 10);

        colourRows.forEach((row, index) => {
          row.hidden = index >= quantity;
        });
        form.dataset.vrlBundleQuantity = String(quantity);
        submitButton.textContent = choice.dataset.vrlButtonLabel || submitButton.textContent;
        status.textContent = '';
      };

      choices.forEach((choice) => choice.addEventListener('change', updateBundle));
      updateBundle();

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.vrlSubmitting === 'true') return;

        const choice = choices.find((item) => item.checked);
        if (!(choice instanceof HTMLInputElement)) return;
        const quantity = Number.parseInt(choice.value, 10);
        const selectedIds = colourRows.slice(0, quantity).map((row) => {
          const select = row.querySelector('[data-vrl-bundle-variant]');
          return select instanceof HTMLSelectElement ? select.value : '';
        }).filter(Boolean);

        if (selectedIds.length !== quantity) return;

        const quantities = selectedIds.reduce((items, id) => {
          items[id] = (items[id] || 0) + 1;
          return items;
        }, {});
        const items = Object.entries(quantities).map(([id, itemQuantity]) => ({ id, quantity: itemQuantity }));
        const buttonLabel = choice.dataset.vrlButtonLabel || submitButton.textContent;

        form.dataset.vrlSubmitting = 'true';
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        status.textContent = status.dataset.addingLabel || '';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('bundle_add_failed');
          window.location.assign(`${root}cart`);
        } catch (error) {
          form.dataset.vrlSubmitting = 'false';
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          submitButton.textContent = buttonLabel;
          status.textContent = status.dataset.errorLabel || '';
        }
      });
    });
  });

  document.querySelectorAll('.vrl-faq').forEach((faq) => {
    faq.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        faq.querySelectorAll('details[open]').forEach((openItem) => {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
